import { Injectable } from '@angular/core';
import { Observable } from "rxjs";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { environment } from "../../environments/environment";

@Injectable({
  providedIn: 'root'
})
export class TemplateService {

  constructor(private http: HttpClient) {}

  getTemplates(requirementId) {
    return this.http.get(`${environment.apiUrl}/trackvision/template/get/${requirementId}`);
  }

  getCustomTemplates(templateId,requirementId) {
    return this.http.get(`${environment.apiUrl}/trackvision/template/getcustomfields/${templateId}/${requirementId}`);
  }

  getTemplateRecords(requirementId) {
    return this.http.get(`${environment.apiUrl}/trackvision/template/gettemplaterecords/${requirementId}`);
  }

  Delete(body) {
    return this.http.post(`${environment.apiUrl}/trackvision/template/delete`,body,
      {
        headers: new HttpHeaders().set(
          "Token",
          localStorage.getItem("access_token") || ""
        ),
      });
  }

  createClause(body) {
    return this.http.post(`${environment.apiUrl}/trackvision/template/flowsgenerate`,body,
      {
        headers: new HttpHeaders().set(
          "Token",
          localStorage.getItem("access_token") || ""
        ),
      }
    );
  }
}
